import api from "services/api";
import type {
  CentroCustoApi,
  DashboardCentroCustoParams,
  ResumoSegmentadoApiResponse,
  TipoCentroCusto,
} from "../types/centro-custo.types";

export async function listarCentrosCusto(params?: {
  ativo?: boolean;
  tipo?: TipoCentroCusto;
  sincronizarEventosAtivos?: boolean;
  somenteEventosAtivos?: boolean;
}): Promise<{ data: CentroCustoApi[] | null; status: number }> {
  const search = new URLSearchParams();
  if (params?.ativo !== undefined) search.set("ativo", String(params.ativo));
  if (params?.tipo) search.set("tipo", params.tipo);
  if (params?.sincronizarEventosAtivos !== undefined) {
    search.set("sincronizarEventosAtivos", String(params.sincronizarEventosAtivos));
  }
  if (params?.somenteEventosAtivos !== undefined) {
    search.set("somenteEventosAtivos", String(params.somenteEventosAtivos));
  }
  const qs = search.toString();
  const url = `/loja/financeiro/centros-custo${qs ? `?${qs}` : ""}`;
  const res = await api.get<CentroCustoApi[]>(url);
  if (res.status !== 200) return { data: null, status: res.status };
  return { data: res.data ?? [], status: res.status };
}

export async function garantirCentroCustoEvento(
  eventoId: number,
): Promise<{ data: CentroCustoApi | null; status: number }> {
  const res = await api.get<CentroCustoApi>(
    `/loja/financeiro/centros-custo/evento/${eventoId}`,
  );
  if (res.status !== 200) return { data: null, status: res.status };
  return { data: res.data ?? null, status: res.status };
}

export async function obterDashboardCentroCusto(
  params: DashboardCentroCustoParams,
): Promise<{ data: ResumoSegmentadoApiResponse | null; status: number }> {
  const search = new URLSearchParams();
  if (params.dataInicio) search.set("dataInicio", params.dataInicio);
  if (params.dataFim) search.set("dataFim", params.dataFim);
  if (params.centroCustoId) search.set("centroCustoId", params.centroCustoId);
  if (params.eventoId != null) search.set("eventoId", String(params.eventoId));
  if (params.tipoCentro) search.set("tipoCentro", params.tipoCentro);

  const qs = search.toString();
  const url = `/loja/financeiro/dashboard-centro-custo${qs ? `?${qs}` : ""}`;
  const res = await api.get<ResumoSegmentadoApiResponse>(url);
  if (res.status !== 200) return { data: null, status: res.status };
  return { data: res.data ?? null, status: res.status };
}
